module.exports = __webpack_public_path__ + "static/img/banner_home_22.a84cad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/index/banner_home_22.jpg
// module id = zgb7
// module chunks = 0